import { registerPlugin } from '@capacitor/core';
const StatusBar = registerPlugin('StatusBar');
export * from './definitions';
export { StatusBar };
